<div class="modal-header">
  <h2>{{ 'EDIT_PROMPT.TITLE' | translate }}</h2>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body py-lg-10 px-lg-10" style="overflow-y: auto; max-height: calc(100vh - 200px);"
cdkScrollable>
  <div class="stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid" id="kt_modal_create_app_stepper">
      <!-- Navigation Section -->
      <div class="d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px">
          <div class="stepper-nav ps-lg-10">
              <ng-container *ngFor="let step of steps; let i = index">
                  <div style="cursor: pointer;" class="stepper-item" [class.current]="currentStep === i + 1" (click)="setStep(i + 1)">
                      <div class="stepper-wrapper">
                          <div class="stepper-icon w-40px h-40px">
                              <i class="ki-duotone ki-check stepper-check fs-2"></i>
                              <span class="stepper-number">{{ i + 1 }}</span>
                          </div>
                          <div class="stepper-label">
                              <h3 class="stepper-title">{{ step.title | translate }}</h3>
                              <div class="stepper-desc">{{ step.description | translate }}</div>
                          </div>
                      </div>
                      <div class="stepper-line h-40px" *ngIf="i < steps.length - 1">
                      </div>
                  </div>
              </ng-container>
          </div>
      </div>
      <!-- Content Section -->
      <div class="flex-row-fluid py-lg-5 px-lg-15">
          <form class="form" (ngSubmit)="onSubmit()" #form="ngForm">
              <!-- Step 1: Details -->
              <div *ngIf="currentStep === 1">
                  <div class="fv-row mb-10">
                      <label class="fs-5 fw-semibold mb-2">{{ 'EDIT_PROMPT.COMPANY_NAME' | translate }}</label>
                      <input type="text" class="form-control form-control-lg form-control-solid" name="company" [(ngModel)]="formData.company" required [ngClass]="{'modified': modifiedFields['company']}" (ngModelChange)="trackFieldChange('company')" />
                      <small class="text-muted mt-2"> {{ 'EDIT_PROMPT.TOTAL_CHARACTERS' | translate }} {{ characterCounts.company }}</small>
                  </div>
                  <div class="fv-row mb-10">
                      <label class="fs-5 fw-semibold mb-2">{{ 'EDIT_PROMPT.BOT_NAME' | translate }}</label>
                      <input type="text" class="form-control form-control-lg form-control-solid" name="name" [(ngModel)]="formData.name" required [ngClass]="{'modified': modifiedFields['name']}" (ngModelChange)="trackFieldChange('name')" />
                      <small class="text-muted mt-2"> {{ 'EDIT_PROMPT.TOTAL_CHARACTERS' | translate }} {{ characterCounts.name }}</small>
                  </div>
              </div>
              <!-- Step 2: Language Selection and Initial Settings -->
              <div *ngIf="currentStep === 2">
                  <div class="fv-row mb-10">
                      <label class="fs-5 fw-semibold mb-2">{{ 'EDIT_PROMPT.LANGUAGE' | translate }}</label>
                      <select class="form-select form-select-lg form-select-solid" [(ngModel)]="formData.language" name="language" required [ngClass]="{'modified': modifiedFields['language']}" (ngModelChange)="trackFieldChange('language')">
                          <option value="German">{{ 'EDIT_PROMPT.GERMAN' | translate }}</option>
                          <option value="Polish">{{ 'EDIT_PROMPT.POLISH' | translate }}</option>
                      </select>
                      <!-- <small class="text-muted mt-2">Suma znaków:  {{ characterCounts.language }}</small> -->
                  </div>
                  <div class="fv-row mb-10">
                      <label class="fs-5 fw-semibold mb-2">{{ 'EDIT_PROMPT.INITIAL_SETTINGS' | translate }}</label>
                      <textarea class="form-control form-control-lg form-control-solid" [(ngModel)]="formData.entry_settings" name="entry_settings" required [ngClass]="{'modified': modifiedFields['entry_settings']}" (ngModelChange)="trackFieldChange('entry_settings')" style="width: 100%; height: 200px;"></textarea>
                      <small class="text-muted mt-2"> {{ 'EDIT_PROMPT.TOTAL_CHARACTERS' | translate }} {{ characterCounts.entry_settings }}</small>
                  </div>
                  <!-- <div class="fv-row mb-10">
          <label *ngIf="!clonedPromptAvailable" class="fs-5 fw-semibold mb-2">Skopiuj obecny prompt</label>
          <label *ngIf="clonedPromptAvailable" class="fs-5 fw-semibold mb-2">Wklej skopiowany prompt</label>
          <div class="d-flex gap-2">
            <button 
            *ngIf="!clonedPromptAvailable" 
            type="button" 
            class="btn btn-primary btn-shadow btn-sm" 
            (click)="clonePrompt()"
          >
            <i class="fas fa-copy"></i> Clone Prompt
          </button>
          <button
            type="button" 
            class="btn btn-success btn-shadow btn-sm"
            *ngIf="clonedPromptAvailable"
            (click)="pastePrompt()"
          >
            <i class="fas fa-paste"></i> Paste Prompt to Current Campaign
          </button>
          
          </div>
        </div> -->
                  <div class="fv-row mb-10">
                      <label *ngIf="!clonedPromptAvailable" class="fs-5 fw-semibold mb-2">{{ 'EDIT_PROMPT.CLONE_CURRENT_PROMPT' | translate }}</label>
                      <label *ngIf="clonedPromptAvailable" class="fs-5 fw-semibold mb-2">{{ 'EDIT_PROMPT.PASTE_CLONED_PROMPT' | translate }}</label>
                      <div class="d-flex gap-2">
                          <button *ngIf="!clonedPromptAvailable" type="button" class="btn btn-primary btn-shadow btn-sm" (click)="clonePrompt()">
                              <i class="fas fa-copy"></i> {{ 'EDIT_PROMPT.CLONE_PROMPT' | translate }}
                          </button>
                          <button type="button" class="btn btn-success btn-shadow btn-sm" *ngIf="clonedPromptAvailable" (click)="pastePrompt()">
                              <i class="fas fa-paste"></i> {{ 'EDIT_PROMPT.PASTE_PROMPT_CURRENT_CAMPAIGN' | translate }}
                          </button>
                      </div>
                  </div>


              </div>
              <!-- Step 3: Additional Settings and Hangup Sentence -->
              <div *ngIf="currentStep === 3">
                  <div class="fv-row mb-10">
                      <label class="fs-5 fw-semibold mb-2">
                          {{ 'EDIT_PROMPT.EXTRA_SETTINGS' | translate }}
                      </label>
                      <textarea class="form-control form-control-lg form-control-solid" [(ngModel)]="formData.extra_settings" name="extra_settings" [ngClass]="{'modified': modifiedFields['extra_settings']}" (ngModelChange)="trackFieldChange('extra_settings')" style="width: 100%; height: 200px;"></textarea>
                      <small class="text-muted mt-2">
            {{ 'EDIT_PROMPT.TOTAL_CHARACTERS' | translate }} {{ characterCounts.extra_settings }}
          </small>
                  </div>
                  <div class="fv-row mb-10">
                      <label class="fs-5 fw-semibold mb-2">
                          {{ 'EDIT_PROMPT.HANGUP_SENTENCE' | translate }}
                      </label>
                      <select class="form-select form-select-lg form-select-solid" name="hangup_setence" [(ngModel)]="formData.hangup_setence" required [ngClass]="{'modified': modifiedFields['hangup_setence']}" (ngModelChange)="trackFieldChange('hangup_setence')">
                          <option *ngFor="let sentence of hangupSentences" [value]="sentence">
                              {{ sentence }}
                          </option>
                      </select>
                      <small class="text-muted mt-2">
            {{ 'EDIT_PROMPT.TOTAL_CHARACTERS' | translate }} {{ characterCounts.hangup_setence }}
          </small>
                  </div>
              </div>
              <!-- Step 4: Tasks Section -->
              <div *ngIf="currentStep === 4">
                <label class="fs-5 fw-bold">
                  {{ 'EDIT_PROMPT.TASKS' | translate }}
                </label>
                <br>
                <label class="fs-7 fw-regular mb-2">
                  {{ 'EDIT_PROMPT.TOTAL_CHARACTERS' | translate }} {{ totalStepCharacters }}
                </label>
              
                <!-- Scrollable Tasks List -->
                <div style="max-height: 400px; overflow-y: auto;" cdkDropList (cdkDropListDropped)="drop($event)" #taskList>
                  <div
                    *ngFor="let stepItem of formData.steps; let i = index"
                    cdkDrag
                    class="mb-5"
                  >
                    <label class="fs-6 fw-semibold d-block mb-1">
                      {{ 'EDIT_PROMPT.STEP' | translate }} {{ i + 1 }}
                    </label> 
                    <div class="d-flex align-items-center position-relative mb-2">
                         <!-- Draggable Icon -->
                         <i
                         class="fa-solid fa-grip-vertical me-3"
                         cdkDragHandle
                         style="cursor: grab; margin-top: 6px;"
                       ></i>
                        <!-- Textarea -->
                        <textarea
                          class="form-control form-control-solid me-2"
                          style="flex: 1; width: 100%; height: auto!important"
                          [(ngModel)]="stepItem.step"
                          name="step-{{ i }}"
                          placeholder="{{ 'EDIT_PROMPT.TASK_DESCRIPTION' | translate }}"
                          required
                          [ngClass]="{ modified: modifiedFields['step-' + i] }"
                          (ngModelChange)="trackFieldChange('step-' + i)"
                        ></textarea>
                      
                       
                      
                        <!-- Delete (Trash) Icon Button -->
                       
                          <i 
                          class="fa-solid fa-trash text-danger ms-3 me-3"
                          style="cursor: pointer; margin-top: 6px;"
                          (click)="removeStepItem(i)">
                        </i>

                      </div>
                      
                  
               <!-- Remove Button -->
              
              
                  </div>
                       
                </div>
              
                <!-- Add New Task -->
                <div class="d-flex align-items-center mt-3">
                  <span (click)="addStepItem()" class="cursor-pointer text-muted d-flex align-items-center">
                    <i class="fas fa-plus me-2"></i> {{ 'EDIT_PROMPT.ADD_TASK' | translate }}
                  </span>
                </div>
              </div>
              
              
              
              <!-- Step 5: FAQ Section -->
              <div *ngIf="currentStep === 5">
                  <label class="fs-5 fw-bold">
                      {{ 'EDIT_PROMPT.FAQ' | translate }}
                  </label>
                  <br>
                  <label class="fs-7 fw-regular">
                      {{ 'EDIT_PROMPT.TOTAL_CHARACTERS' | translate }} {{ totalFaqCharacters }}
                  </label>
                  <br>
                  <label class="fs-7 fw-regular mb-2">
                      {{ 'EDIT_PROMPT.NUMBER_OF_QUESTIONS' | translate }} {{ totalFaqQuestions }}
                  </label>
                  <!-- Show FAQ List only if there are FAQs -->
                  <div *ngIf="formData.faq.length > 0" style="max-height: 450px; overflow-y: auto;" #faqList>
                      <div *ngFor="let faqItem of formData.faq; let i = index" class="mb-5 mt-5 me-5">
                          <!-- Question Input -->
                          <label class="fs-6 fw-semibold mb-1">
                              {{ 'EDIT_PROMPT.QUESTION' | translate }}
                          </label>
                          <input type="text" class="form-control form-control-solid me-2 position-relative" [(ngModel)]="faqItem.question" name="question-{{ i }}" placeholder="{{ 'EDIT_PROMPT.QUESTION' | translate }}" [ngClass]="{'modified': modifiedFields['question-' + i]}" (ngModelChange)="trackFieldChange('question-' + i)">
                          <!-- Answer Input -->
                          <label class="fs-6 fw-semibold mt-3">
                              {{ 'EDIT_PROMPT.ANSWER' | translate }}
                          </label>
                          <textarea class="form-control form-control-solid me-2 position-relative" [(ngModel)]="faqItem.answer" name="answer-{{ i }}" placeholder="{{ 'EDIT_PROMPT.ANSWER' | translate }}" [ngClass]="{'modified': modifiedFields['answer-' + i]}" (ngModelChange)="trackFieldChange('answer-' + i)"
                          style="height: 90px;"></textarea>
                          <!-- Assigned Tags Display with Delete FAQ Button -->
                          <div class="d-flex justify-content-between align-items-center mt-5 mb-5">
                              <div> {{ 'CAMPAIGN.TAGS' | translate }}: <span *ngIf="faqItem.tags.length > 0" class="badge rounded-pill text-white me-2 fs-7" [ngStyle]="{'background-color': faqItem.tags[0]?.color}">
                  {{ faqItem.tags[0]?.value }}
                  <i class="fa-solid fa-times text-white ms-2 fs-9" style="cursor: pointer;" (click)="removeTag(i, faqItem.tags[0].id)"></i>
                </span>
                                  <span *ngIf="faqItem.tags.length === 0" class="badge rounded-pill bg-dark cursor-pointer text-white fs-7" (click)="openTagModal(i)">
                  {{ 'EDIT_PROMPT.ADD_TAG' | translate }}
                  <i class="fa-solid fa-plus text-white ms-2 fs-9"></i>
                </span>
                              </div>
                              <!-- Delete FAQ Button -->
                              <button type="button" class="btn btn-danger" (click)="removeFaqItem(i)" style="padding: 4px 8px; font-size: 1rem; height: auto;">
                                  {{ 'Delete' | translate }}
                              </button>
                          </div>
                          <div class="separator separator-dashed my-3"></div>
                      </div>
                  </div>
                  <!-- Show Add FAQ Button even when FAQ list is empty -->
                  <div class="d-flex align-items-center mt-3">
                      <span (click)="addFaqItem()" class="cursor-pointer text-muted d-flex align-items-center">
            <i class="fas fa-plus me-2"></i>
            {{ 'EDIT_PROMPT.ADD_FAQ' | translate }}
          </span>
                  </div>
              </div>
          </form>
      </div>
  </div>
</div>
<div *ngIf="isReopened" class="modal-footer">
  <div class="d-flex justify-content-between w-100 pt-10 mt-5">
      <div class="d-flex">
          <button type="button" class="btn btn-sm btn-light-primary me-3" *ngIf="currentStep > 1" (click)="previousStep()">
              <i class="fa-solid fa-arrow-left"></i> {{ 'EDIT_PROMPT.BACK' | translate }}
          </button>
           <!-- Export and Import buttons visible only on step 4 -->
           <button type="button" class="btn btn-sm btn-info me-3" *ngIf="currentStep === 4" (click)="onExportTasks()">
            {{ 'EDIT_PROMPT.EXPORT_CSV' | translate }}
        </button>
        <input type="file" accept=".csv" (change)="handleFileInputTasks($event)" style="display: none;" #fileInputTasks />
        <button type="button" class="btn btn-sm btn-warning me-3" *ngIf="currentStep === 4" (click)="fileInputTasks.click()">
            {{ 'EDIT_PROMPT.IMPORT_CSV' | translate }}
        </button>
          <!-- Export and Import buttons visible only on step 5 -->
          <button type="button" class="btn btn-sm btn-info me-3" *ngIf="currentStep === 5" (click)="onExport()">
              {{ 'EDIT_PROMPT.EXPORT_CSV' | translate }}
          </button>
          <input type="file" accept=".csv" (change)="handleFileInput($event)" style="display: none;" #fileInput>
          <button type="button" class="btn btn-sm btn-warning me-3" *ngIf="currentStep === 5" (click)="fileInput.click()">
              {{ 'EDIT_PROMPT.IMPORT_CSV' | translate }}
          </button>
          <!-- <button type="button" class="btn btn-sm btn-warning me-3" *ngIf="currentStep === 5" (click)="onImport()">
         {{ 'EDIT_PROMPT.IMPORT_CSV' | translate }}
         </button> -->
          <button type="button" class="btn btn-sm btn-primary" *ngIf="currentStep < steps.length" (click)="nextStep()">
              {{ 'EDIT_PROMPT.NEXT' | translate }}
              <i class="fa-solid fa-arrow-right"></i>
          </button>
      </div>
      <div>
          <button type="button" class="btn btn-sm btn-success" (click)="onSubmit()">
              {{ 'EDIT_PROMPT.SAVE_CHANGES' | translate }}
          </button>
      </div>
  </div>
</div>
<div *ngIf="!isReopened" class="modal-footer">
  <div class="d-flex justify-content-between w-100 pt-10 mt-5">
      <div class="d-flex">
          <button type="button" class="btn btn-sm btn-light-primary me-3" *ngIf="currentStep > 1" (click)="previousStep()">
              <i class="fa-solid fa-arrow-left"></i> {{ 'EDIT_PROMPT.BACK' | translate }}
          </button>
          <!-- Export and Import buttons visible only on step 4 -->
          <button type="button" class="btn btn-sm btn-info me-3" *ngIf="currentStep === 4" (click)="onExportTasks()">
              {{ 'EDIT_PROMPT.EXPORT_CSV' | translate }}
          </button>
          <input type="file" accept=".csv" (change)="handleFileInputTasks($event)" style="display: none;" #fileInputTasks />
          <button type="button" class="btn btn-sm btn-warning me-3" *ngIf="currentStep === 4" (click)="fileInputTasks.click()">
              {{ 'EDIT_PROMPT.IMPORT_CSV' | translate }}
          </button>

          <!-- Export and Import buttons visible only on step 5 -->
          <button type="button" class="btn btn-sm btn-info me-3" *ngIf="currentStep === 5" (click)="onExport()">
              {{ 'EDIT_PROMPT.EXPORT_CSV' | translate }}
          </button>
          <input type="file" accept=".csv" (change)="handleFileInput($event)" style="display: none;" #fileInput>
          <button type="button" class="btn btn-sm btn-warning me-3" *ngIf="currentStep === 5" (click)="fileInput.click()">
              {{ 'EDIT_PROMPT.IMPORT_CSV' | translate }}
          </button>
          <button type="button" class="btn btn-sm btn-primary" *ngIf="currentStep < steps.length" (click)="nextStep()">
              {{ 'EDIT_PROMPT.NEXT' | translate }}
              <i class="fa-solid fa-arrow-right"></i>
          </button>
      </div>
      <div>
          <button type="button" class="btn btn-sm btn-success" (click)="onSubmit()">
              {{ 'EDIT_PROMPT.SAVE' | translate }}
          </button>
      </div>
  </div>
</div>